<script>
import modal from '@/components/view/modal'
import videoPlayer from '@/components/view/video-player'
import overflowScroller from '@/components/view/overflow-scroller'
// import tweetsList from '@/components/view/tweets-list'
export default {
  components: {
    'gp-modal': modal,
    'video-player': videoPlayer,
    'overflow-scroller': overflowScroller
    // 'tweets-list': tweetsList
  },
  props: ['isMobile', 'topVisualIndex', 'scrollTop'],
  data: () => ({
    topVideoKey: '016',
    autoPlayVideoKey: '016',
    newsIndex: null,
    showPoster: false,
    getTweetFlg: false,
    tweets: []
  }),
  computed: {
    videoId () {
      return this.$route.hash.replace('#', '')
    },
    newsList () {
      const list = [
        {...this.docs.news[0]},
        {...this.docs.news[1]},
        {...this.docs.news[2]}
      ]
      if (this.isMobile) {
        return list
      } else if (this.newsIndex === null) {
        return []
      } else {
        list.forEach(news => {
          if (news.title.length > 50) {
            news.title = news.title.substring(0, 45) + '…'
          }
        })
        return [list[this.newsIndex % 3]]
      }
    },
    topVideo () {
      return {
        ...this.docs.video[this.topVideoKey],
        id: this.topVideoKey
      }
    },
    videoList () {
      const keys = Object.keys(this.docs.video)
        .sort((a, b) => a > b ? -1 : 1)
      const videoList = []
      keys.forEach(key => {
        videoList.push({
          ...this.docs.video[key],
          id: key
        })
      })
      return videoList
    },
    countdown () {
      const keys = Object.keys(this.docs.special)
      return {
        id: keys[0],
        ...this.docs.special[keys[0]]
      }
    },
    query () {
      return '#今週もプリテンドされました #灼熱の要塞BOX #特装版にはスペシャル割り箸つき #ご自宅でも割り箸アクション #グレプリBDもお願いします #グレプリ'.replace(/#/g, '%23')
    },
    shareUrl () {
      return `https://twitter.com/share?url=https://www.greatpretender.jp/special/fake02&text=${this.query}`
    },
    iizoQuery () {
      return 'グレプリはいいぞ'
    },
    iizoShareUrl () {
      return `https://twitter.com/intent/tweet?hashtags=${this.iizoQuery}`
    }
  },
  watch: {
    /* scrollTop (value) {
      if (value > 100 && !this.getTweetFlg) {
        this.getTweetFlg = true
        this.xhr()
      }
    } */
  },
  mounted () {
    this.increment()
    if (!sessionStorage.getItem('topvideo')) {
      sessionStorage.setItem('topvideo', 'played')
      this.$router.push({ name: 'home', hash: '#' + this.autoPlayVideoKey })
    }
  },
  methods: {
    increment () {
      this.newsIndex === null ? this.newsIndex = 0 : this.newsIndex++
      setTimeout(this.increment, 6000)
    },
    setPos (val) {
      if (val > 0) {
        this.showPoster = true
      }
    },
    xhr () {
      // const url = 'https://tapi.scivone-api.com/lookup/grepreiizo'
      const url = 'https://tapi.scivone-api.com/hashtag/grepreiizo'
      const xhr = new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.onreadystatechange = () => {
          switch (xhr.readyState) {
            case 4:
              if (xhr.status && xhr.status < 300) {
                const response = JSON.parse(xhr.responseText)
                resolve(response)
              } else {
                reject(new Error(xhr.responseText))
              }
          }
        }
        xhr.send()
      })
      xhr.then(res => {
        const statuses = res.statuses
        for (let i = statuses.length - 1; i > 0; i--) {
          const rand = Math.floor(Math.random() * (i + 1))
          const [a, b] = [statuses[rand], statuses[i]]
          statuses[i] = a
          statuses[rand] = b
        }
        this.tweets = statuses
      })
        .catch(error => console.error(error))
    }
  }
}
</script>

<template>
  <div class="gp-home">
    <section class="top-visual-container">
      <nav>
        <div class="has-text-align-center has-text-weight-bold is-size-3 is-size-5-mobile">CHANGE</div>
        <ul>
          <li
            class="nav-v4"
            :class="{current: topVisualIndex === 4}"
            @click="$emit('changeTopVisual', 4)"
          ></li>
          <li
            class="nav-v3"
            :class="{current: topVisualIndex === 3}"
            @click="$emit('changeTopVisual', 3)"
          ></li>
          <li
            class="nav-v1"
            :class="{current: topVisualIndex === 1}"
            @click="$emit('changeTopVisual', 1)"
          ></li>
          <li
            class="nav-v2"
            :class="{current: topVisualIndex === 2}"
            @click="$emit('changeTopVisual', 2)"
          ></li>
        </ul>
      </nav>
      <div
        class="case4-copy"
        v-if="topVisualIndex === 3"
      ></div>
      <!--<a href="https://twitter.com/search?q=%23%E3%82%B0%E3%83%AC%E3%83%97%E3%83%AA%E3%81%AF%E3%81%84%E3%81%84%E3%81%9E" target="_blank" rel="noopener">
        <div class="copy-iizo"></div>
      </a>
      <div class="copy-love"></div>
      <div class="tweet-hashtag">
        <a :href="iizoShareUrl" target="_blank" rel="noopener">
          <button class="is-size-3">#グレプリはいいぞ、でツイート</button>
        </a>
      </div>-->
    </section>
    <div class="banner">
      <router-link :to="{name: 'home', hash: '#014'}">
        <div class="top-banner-movie"></div>
      </router-link>
      <!-- <router-link
        class="top-banner-wrapper"
        :to="{name: 'special-article', params: {specialId: countdown.id}}"
      >
        <div
          class="top-banner top-banner-countdown"
          :style="{backgroundImage: 'url(' + countdown.image + ')'}"
        ></div>
      </router-link> -->
      <!-- <router-link
        class="top-banner-wrapper"
        :to="{name: 'special-article', params: {specialId: 'interview01'}}"
      >
        <div
          class="top-banner top-banner-radio"
          style="background-image: url(/assets/images/special-banner-interview01.jpg);"
        ></div>
      </router-link> -->
      <!-- <a href="https://www.onsen.ag/program/grepre" target="_blank" rel="noopener">
        <div class="top-banner top-banner-radio"></div>
      </a> -->
      <!-- <a href="https://www.onsen.ag/program/grepre" target="_blank" rel="noopener">
        <div class="top-banner top-banner-radio"></div>
      </a> -->
      <!-- <a href="https://magcomi.com/episode/13933686331653199963" target="_blank" rel="noopener" class="top-banner-comic-wrapper">
        <div class="top-banner top-banner-comic"></div>
      </a> -->
      <!-- <a href="https://plus-ultra.tv/" target="_blank" rel="noopener">
        <div class="top-copy-plus-ultra"></div>
      </a> -->
      <!-- <a href="https://www.netflix.com/jp/title/81220435" target="_blank" rel="noopener">
        <div class="top-copy-netflix"></div>
      </a> -->
    </div>
    <div class="news-wrapper">
      <section class="news is-size-3 is-size-5-mobile">
        <ul
          class="level"
          v-if="isMobile"
        >
          <li
            v-for="news in newsList"
            :key="news.id"
          >
            <router-link :to="{name: 'news-article', params: {newsId: news.id}}">
              <span class="is-family-oswald">{{ news.date }}</span>
              <span>{{ news.title }}</span>
            </router-link>
          </li>
        </ul>
        <ul
          class="level"
          v-else
        >
          <transition name="marquee">
            <li
              v-for="news in newsList"
              :key="news.id"
            >
              <router-link :to="{name: 'news-article', params: {newsId: news.id}}">
                <span class="is-family-oswald">{{ news.date }}</span>
                <span>{{ news.title }}</span>
              </router-link>
            </li>
          </transition>
        </ul>
        <div class="news-more is-hidden-not-mobile has-text-align-center">
          <router-link :to="{name: 'news'}">
            <span class="is-family-oswald has-text-weight-bold is-size-5">MORE</span>
            <img src="@/assets/icon-arrow-right.svg">
          </router-link>
        </div>
      </section>
    </div>
    <!--<tweets-list
      v-if="tweets.length"
      :tweets="tweets"
      :iizoShareUrl="iizoShareUrl"
    ></tweets-list>-->
    <section class="movie">
      <div class="top-video video is-large">
        <p class="copy1">史上最高の詐欺師が、宴に舞い戻る前夜—。</p>
        <router-link :to="{name: 'home', hash: '#' + topVideo.id}">
          <figure></figure>
        </router-link>
        <p class="copy2">2024年2月23日DMM TVにて配信開始！</p>
      </div>
      <h1 class="is-family-oswald has-text-align-center has-text-weight-bold">MOVIE</h1>

      <div class="video-list">
        <overflow-scroller autoScroll @setPos="setPos">
          <ul class="level is-mobile">
            <li
              class="video"
              v-for="(video, i) in videoList"
              :key="video.id"
            >
              <router-link :to="{name: 'home', hash: '#' + video.id}">
                <figure>
                  <img v-if="i < 3 || showPoster"
                    :src="video.image"
                    :alt="video.title"
                  >
                </figure>
                <div class="title has-text-weight-bold is-size-2 is-size-4-mobile">{{ video.title }}</div>
              </router-link>
            </li>
          </ul>
        </overflow-scroller>
      </div>
    </section>
    <section class="fake level-left">
      <router-link :to="{name: 'bd', params: {bdId: 'case1'}}">
        <img src="/assets/images/top-banner-bd.jpg">
      </router-link>
      <a
        :href="shareUrl"
        target="_blank"
        rel="noopener"
      >
        <img src="/assets/images/top-banner-fake3.jpg">
      </a>
    </section>
    <transition name="slide-up">
      <gp-modal v-if="videoId" :route="{name: 'home'}">
        <video-player
          :videoId="videoId"
          :visibleList="false"
          :route="{name: 'home'}"
        />
      </gp-modal>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.gp-home {
  position: relative;
  width: 100%;
  overflow: hidden;
  section {
    @include is-not-mobile {
      max-width: 72.5rem;
      padding-left: 17rem;
      margin: auto;
    }
  }
  .top-visual-container {
    position: relative;
    @include is-mobile {
      //height: 100vh;
      height: calc(100vw * 75 / 43);
      //max-height: 728px;
      width: 100%;
    }
    @include is-not-mobile {
      width: 100vw;
      height: 100vh;
      max-width: 100%;
      max-height: 80rem;
      min-height: 40rem;
      min-width: 65rem;
      padding: 0;
      margin: auto;
    }
    nav {
      position: absolute;
      z-index: 9;
      @include is-mobile {
        bottom: .75rem;
        width: 100%;
      }
      @include is-not-mobile {
        // 遅延表示 とりあえず短くしておく
        animation: enter-banner .15s .5s ease-out forwards;
        //animation: enter-banner .15s 1.5s ease-out forwards;
        transform: translate(400px, 0);
        bottom: 1rem;
        right: 1.5rem;
      }
      div {
        color: $red-dark;
        margin-bottom: .25rem;
      }
      ul {
        @include is-mobile {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        li {
          box-sizing: content-box;
          cursor: pointer;
          border-radius: 10rem;
          border: solid 6px transparent;
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
          &:hover {
            animation: small-expansion .2s 0s ease-out forwards;
          }
          &.current {
            border: solid 6px $red-dark;
          }
          @include is-mobile {
            width: 3rem;
            height: 3rem;
            margin-right: .25rem;
          }
          @include is-not-mobile {
            width: 4.5rem;
            height: 4.5rem;
            margin-bottom: .25rem;
          }
        }
        li.nav-v1 {
          background-image: url("/assets/images/top-icon-v1.png");
        }
        li.nav-v2 {
          background-image: url("/assets/images/top-icon-v2.png");
        }
        li.nav-v3 {
          background-image: url("/assets/images/top-icon-v3.png");
        }
        li.nav-v4 {
          background-image: url("/assets/images/top-icon-v4.png");
        }
      }
    }
  }
  .banner {
    @include is-not-mobile {
      position: absolute;
      top: 0;
      right: 0;
      height: 100vh;
      max-height: 80rem;
      min-height: 48rem;
      transform: translate(400px, 0);
      // 遅延表示 とりあえず短くしておく
      animation: enter-banner .15s .5s ease-out forwards;
      // animation: enter-banner .15s 1.5s ease-out forwards;
    }
    @keyframes enter-banner {
      0% {transform: translate(400px, 0);}
      100% {transform: translate(0, 0);}
    }
    div {
      z-index: 10;
      transition: all .1s ease-out;
      background-size: contain;
      background-position: left center;
      background-repeat: no-repeat;
    }
    @include is-not-mobile {
      div:hover:not(.top-banner) {
        // width: 22rem;
        transform: scale(1.03);
      }
    }
  }
  .top-banner {
    &:hover {
      animation: small-expansion .2s 0s ease-out forwards;
    }
    @include is-mobile {
      width: 300px;
      height: 90px;
      margin: .75rem auto 1rem;
    }
    @include is-not-mobile {
      width: 240px;
      height: 72px;
      position: absolute;
      right: 1.5rem;
    }
  }
  .case4-copy {
    position: absolute;
    background: url('/assets/images/top-copy4_2x.png') no-repeat;
    background-size: contain;
    opacity: 0;
    animation: case4-copy .6s 1.875s ease-out forwards;
    @include is-mobile {
      width: 2rem;
      height: 25rem;
      left: .75rem;
      top: 8.5rem;
    }
    @include is-not-mobile {
      width: 5rem;
      height: calc(100% - 18rem);
      left: calc(35% - 100vh / 8 + .75rem);
      top: 18rem;
      z-index: 9;
    }
    @keyframes case4-copy {
      0% {transform: translate(0, -50px); opacity: 0;}
      100% {transform: translate(0, 0); opacity: 1;}
    }
  }
  .top-visual-container {
    .tweet-hashtag {
      position: absolute;
      @include is-mobile {
        bottom: 2.5rem;
      }
      @include is-not-mobile {
        bottom: 10rem;
        left: calc((100vw + 10rem) / 2);
        margin-left: -10rem;
        transform: translate(-2400px, 0);
        animation: enter-tweet-hashtag .12s 2s ease-out forwards;
      }
      @keyframes enter-tweet-hashtag {
        0% {transform: translate(-600px, 0);}
        100% {transform: translate(0, 0);}
      }
    }
  }
  .tweet-hashtag {
    @include is-mobile {
      width: 100%;
      text-align: center;
    }
    @include is-not-mobile {
      button {
        width: 19rem;
        padding: 0;
        &:hover {
          animation: small-expansion .2s 0s ease-out forwards;
        }
      }
    }
  }
  .top-banner-countdown {
    bottom: 11.75rem;
  }
  .top-banner-radio {
    bottom: 6.5rem;
    background-image: url('/assets/images/top-banner-radio.png');
  }
  .top-banner-comic {
    bottom: 1.25rem;
    background-image: url('/assets/images/top-banner-comic.gif');
  }
  .top-copy-plus-ultra {
    @include is-mobile {
      background-image: url('/assets/images/top-copy-plus-ultra_sp_2x.png');
      margin: .75rem auto;
      width: 15rem;
      height: 4rem;
    }
    @include is-not-mobile {
      background-image: url('/assets/images/top-copy-plus-ultra_pc_2x.png');
      background-color: $black;
      position: absolute;
      top: 1.5rem;
      right: 0;
      width: 21rem;
      height: 5.5rem;
    }
  }
  .top-banner-movie {
    background-image: url('/assets/images/top-banner-movie.png');
    @include is-mobile {
      margin: 1rem auto;
      width: 18.75rem;
      height: 15.25rem;
    }
    @include is-not-mobile {
      position: absolute;
      top: 5rem;
      right: 0;
      width: 15rem;
      height: 12.5rem;
    }
  }
  .top-copy-netflix {
    background-image: url('/assets/images/top-copy-netflix.png');
    background-color: $red-light;
    @include is-mobile {
      margin: auto;
      margin-bottom: 1.5rem;
      width: 18.75rem;
      height: 3.25rem;
    }
    @include is-not-mobile {
      position: absolute;
      top: 7.5rem;
      right: 0;
      width: 21rem;
      height: 3.5rem;
    }
  }
  .news-wrapper {
    background-color: $black;
    color: $white;
    @include is-not-mobile {
      li {
        white-space: nowrap;
      }
    }
    @include is-mobile {
      .news ul {
        padding: .5rem;
        li {
          border-bottom: solid 1px $white;
          padding: .5rem .25rem;
          a {
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
    @include is-not-mobile {
      min-width: 100%;
      overflow: hidden;
      ul {
        position: relative;
        width: 100vw;
        height: 4.5rem;
        margin-left: 3rem;
        li {
          position: absolute;
          min-width: 100%;
        }
      }
    }
    .news-more {
      padding-bottom: .5rem;
      a {
        width: 100%;
        display: block;
      }
    }
  }
  .movie {
    background-color: #E5E5E5;
    @include is-mobile {
      margin-top: 4rem;
    }
    @include is-not-mobile {
      padding: {
        top: 4rem;
        bottom: 4rem;
      }
    }
    .top-video {
      @include is-not-mobile {
        padding-left: 3rem;
      }
      .copy1, .copy2, .copy3, figure {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        color: rgba(0, 0, 0, 0);
      }
      .copy1 {
        position: relative;
        top: 2px;
      }
      /* 無印時代のコピー
      .copy2 {
        background-color: $black;
      }
      @include is-mobile {
        .copy1 {
          background-image: url("/assets/images/top-copy1-sp_2x.png");
          height: 5.25rem;
        }
        .copy2 {
          background-image: url("/assets/images/top-copy2-sp_2x.png");
          height: 6.25rem;
        }
        .copy3 {
          background-image: url("/assets/images/top-copy3-sp_2x.png");
          height: 2.75rem;
          margin-top: .375rem;
        }
      }
      @include is-not-mobile {
        .copy1 {
          background-image: url("/assets/images/top-copy1-pc_2x.png");
          background-position: bottom;
          height: 5rem;
          font-size: 3.5rem;
        }
        .copy2 {
          background-image: url("/assets/images/top-copy2-pc_2x.png");
          height: 5.5rem;
        }
        .copy3 {
          background-image: url("/assets/images/top-copy3-pc_2x.png");
          height: 2.25rem;
          font-size: 1.75rem;
        }
      }
      */
      @include is-mobile {
        .copy1 {
          background-image: url("/assets/images/top-copy-raz1-sp.svg");
          height: 6.75rem;
        }
        .copy2 {
          background-image: url("/assets/images/top-copy-raz2.svg");
          height: 6.5rem;
          margin-top: .375rem;
        }
      }
      @include is-not-mobile {
        .copy1 {
          background-image: url("/assets/images/top-copy-raz1-pc.svg");
          background-position: bottom;
          height: 5rem;
          font-size: 2rem;
        }
        .copy2 {
          background-image: url("/assets/images/top-copy-raz2.svg");
          background-position: top;
          height: 19rem;
          margin-top: 1rem;
          font-size: 2rem;
        }
      }
      figure {
        background-size: cover;
        @include is-mobile {
          background-image: url("/assets/images/top-pv-raz-sp.jpg");
          height: 10rem;
        }
        @include is-not-mobile {
          background-image: url("/assets/images/top-pv-raz-pc.jpg");
          height: 20rem;
        }
      }
    }
    h1 {
      background-color: $black;
      color: $white;
      z-index: 2;
      margin-top: 4rem;
      position: relative;
      @include is-mobile {
        width: 17.5rem;
        height: 3.75rem;
        font-size: 3.125rem;
        line-height: 3.5rem;
        margin-left: 2rem;
        top: 1rem;
      }
      @include is-not-mobile {
        margin-left: 3rem;
        font-size: 3.75rem;
        height: 4.75rem;
        line-height: 4.75rem;
        width: 22rem;
        top: 1.5rem;
      }
    }
    .video-list {
      @include is-mobile {
        width: 100vw;
      }
      @include is-not-mobile {
        margin-left: 3rem;
        height: 287px;
      }
      ul {
        align-items: flex-start;
        li.video {
          @include is-mobile {
            &:first-child {
              padding-left: 2rem;
            }
            padding-right: 1rem;
          }
          @include is-not-mobile {
            padding-right: 3.5rem;
          }
          .title {
            background-color: $red-dark;
            color: $white;
            display: inline-block;
            padding: .25rem 1rem;
          }
          figure {
            background-color: $black;
            @include is-mobile {
              width: 19.5rem;
            }
            @include is-not-mobile {
              width: 445px;
              height: 250px;
            }
          }
        }
      }
    }
  }
  .fake {
    @include is-mobile {
      margin: 4rem auto;
      text-align: center;
      img {
        width: calc(100% - 1rem);
        max-width: 359px;
        margin: 1rem auto;
      }
    }
    @include is-not-mobile {
      padding-bottom: 8rem;
      img {
        width: 27.5rem;
        padding-left: 3rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/home.vue